import React from 'react'
import { Panel, Line } from './fragments/comp/panel'

import Rating from 'components/lib/rating'
import { SubjectRating, useFeedback2API } from './api/feedback2'

export default function Feedback2Info(): JSX.Element {
  const feedbackAPI = useFeedback2API()
  if (feedbackAPI.hasFeedback()) {
    const review = feedbackAPI.getReview()
    return (
      <div className="row">
        <div className="col-12">
          <Panel id="feedback" label="Order Feedback" actions={[]}>
            <Line label="Overall Rating Score">
              <Rating score={feedbackAPI.getSessionAverage()} />
            </Line>
            {review && review.rating && (
              <Line label="Order Review">
                {review.rating.score > 0 && <Rating score={review.rating.score / review.rating.max} />}
                {review.rating.comment && (
                  <div
                    className="panel"
                    style={{
                      padding: '5px 20px',
                      backgroundColor: '#eee',
                      border: '1px solid #bbb',
                    }}
                  >
                    {review.rating.comment}
                  </div>
                )}
              </Line>
            )}
            {feedbackAPI
              .getQuestionsRatings()
              .filter((qr) => !!qr.rating)
              .map((qr: SubjectRating) => (
                <Line key={qr.subject.id} label={qr.subject.name}>
                  <Rating score={qr.rating.score / qr.rating.max} />
                </Line>
              ))}
            {feedbackAPI
              .getItemRatings()
              .filter((qr) => !!qr.rating)
              .map((qr: SubjectRating) => (
                <Line key={qr.subject.id} label={`Item: ${qr.subject.name}`}>
                  <ThumbRating score={(qr.rating.score - qr.rating.min) / (qr.rating.max - qr.rating.min)} />
                  {qr.rating.comment && (
                    <div
                      className="panel"
                      style={{
                        padding: '5px 20px',
                        backgroundColor: '#eee',
                        border: '1px solid #bbb',
                      }}
                    >
                      {qr.rating.comment}
                    </div>
                  )}
                </Line>
              ))}
          </Panel>
        </div>
      </div>
    )
  }
  return <></>
}

import { Icon } from 'react-fa'
function ThumbRating(props: { score: number }): JSX.Element {
  switch (props.score) {
    case 0:
      return <Icon name="thumbs-down" />
    case 1:
      return <Icon name="thumbs-up" />
    default:
      return <>{props.score}</>
  }
}
